import type { AbstractControl, AsyncValidator, ValidationErrors } from '@angular/forms';
import type { Observable } from 'rxjs';

import { InjectionToken } from '@angular/core';

export interface BankingIbanValidatorConfig extends AsyncValidator {
  country: string;

  validate(control: AbstractControl): Observable<ValidationErrors | null>;
}

export const BANKING_IBAN_VALIDATOR_CONFIG = new InjectionToken<BankingIbanValidatorConfig>(
  'BANKING_IBAN_VALIDATOR_CONFIG'
);
